import styled from '@emotion/styled';
import { media } from '../../services/media';

export const FunFactsContent = styled.div`
    position: relative;
    margin: 0 auto;
    min-height: 16vw;

    ${media.min('md')} {
        max-width: 100%;
        min-height: 7.42vw;

        position: static;
    }

    h2 {
        margin-bottom: 1vw;
        font-size: 3vw;

        ${media.min('lg')} {
            font-size: 2.6vw;
        }
    }

    p {
        padding: 0 5vw;

        font-size: 4.4vw;

        ${media.min('md')} {
            padding: 0 2vw;

            margin-bottom: 0;

            font-size: 1.65vw;
            line-height: 2vw;
        }

        ${media.min('lg')} {
            font-size: 1.35vw;
            line-height: 1.7vw;
        }

        &:last-of-type {
            margin-bottom: 1.2em;

            ${media.min('lg')} {
                margin-bottom: 0;
            }
        }
    }
`;
